import React, { useState, useEffect } from 'react';
import { Route, Switch } from "react-router-dom";
import '../common/css/global.css';
import './App.css';
import * as impact from '../common/api/impact';
import LandingPage from "./pages/LandingPage";
import { flights as flightsImpactApi } from '../common/api/impact'
import ImpactPage from "../airport-lim/pages/ImpactPage";

function App() {
  const merchantCode = 'AMADEUS_GLOBAL';
  const [fetchedImpact, setfetchedImpact] = useState();
  const [currentLang, setCurrentLang] = useState(window.localStorage?.getItem("wglang"));

  useEffect(() => {
    flightsImpactApi()
      .then(response => response.json())
      .then(data => setfetchedImpact(data))
      .catch(setfetchedImpact)
  }, []);

  return (
    <>

      <Switch>
        <Route
            exact
            path={`/impact`}
            key="app-amadeus-impact"
        >
          <ImpactPage merchantCode={merchantCode} />
        </Route>
        <Route
          path={`/`}
          key="amadeus-landing"
        >
          <LandingPage
            fetchedImpact={fetchedImpact}
            merchantCode={merchantCode}
            currentLang={currentLang}
            setCurrentLang={setCurrentLang}
          />
        </Route>
      </Switch>
    </>
  );
}

export default App;